const swiperConfig = {
  direction: 'horizontal',
  slidesPerView: 6,
  spaceBetween: 20,
  speed:1500,
  breakpoints: {
    1: {
      slidesPerView: 1,
      spaceBetween: 12,
    },
    320: {
      slidesPerView: 1.8697,
      spaceBetween: 12,
    },
    500: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    700: {
      slidesPerView: 3.05,

    },
    960: {
      slidesPerView: 4.5,
    },
    1100: {
      slidesPerView: 6,
    },
    1280: {
      slidesPerView: 6,
    },
    1600: {
      slidesPerView: 6,
    },
    1920: {
      slidesPerView: 6,
    },
    2560: {
      slidesPerView: 6,
    },
  }
}
class CustomSlider extends HTMLElement {
  constructor() {
      super();
      this.swiper = new Swiper(this, swiperConfig);   
  }
}

customElements.define("custom-swiper", CustomSlider);

